import { Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLanguage } from "src/context/LanguageProvider";
import { formatNumberByType } from "src/utils/formatting";

type Props = {
    year: string | undefined;
    value: string | number;
    unit: string | undefined;
};
export const PreviousValue = (props: Props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { currentLanguage } = useLanguage();

    const { year, value, unit } = props;
    const _valueToDisplay = formatNumberByType(value, unit, currentLanguage);

    return (
        <Typography variant={"small"} sx={{ color: theme.custom.grey[1400] }}>
            {t("my_action_plan.starting_value", "Value in {{year}}: {{value}}{{unit}}", {
                year,
                value: _valueToDisplay,
                unit,
            })}
        </Typography>
    );
};
